import SccAutoComplete from './SccAutoComplete'

export default SccAutoComplete
